export default __webpack_public_path__ + "static/media/gamingbanner.f2e7e333.png";